import { createContext } from 'react';
import { ManagerContextType } from './types';

const defaultContext: ManagerContextType = {
  isReadOnly: true,
  grantManager: () => {
    return;
  },
  revokeManager: () => {
    return;
  },
};

export const ManagerContext = createContext<ManagerContextType>(defaultContext);
